import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { useTheme, Button, Dialog, DialogActions, DialogTitle, FormControl, Select, MenuItem } from '@mui/material';
import BoardType1 from '../../components/BoardType1';
import { TbLoader } from 'react-icons/tb';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  boardListBlock:{
    padding:'235px 0 0 0',

    fontFamily:[
        'Noto Sans KR'
    ],

    [theme.breakpoints.down(1025)]: {
      padding:'132px 0 0 0',
    },
  },

  boardListTitleBlock:{
    height:'200px',
    maxWidth: 1902,
    margin: '0px auto',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    position:'relative'

  },
  boardListH1:{

    fontSize:'38px',
    fontWeight:'500',
    letterSpacing: '-1.9px',
    paddingBottom:'10px',
    position:'absolute',
    top:'40%',
    left:'50%',
    transform:'translate( -50%, -50%)',
    [theme.breakpoints.down(1025)]: {
      fontSize:'2.5rem',
    },
  },
  row:{
    maxWidth:'1280px', 
    margin:'0 auto', 
  },
  boardListDiv:{
    border:'1px solid #ccc',
    background:'#fff',
    height:'80px',
    display:'flex',
    flexWrap:'wrap',
    justifyContent:'space-evenly',
    alignItems:'center',
    position:'absolute',
    top:'-40px',
    left:'0%',
    padding:'15px',
    position:'relative',
    [theme.breakpoints.down(1025)]: {
      display:'none',
    },
  },
  boardListDivM: {
    display:'none',
    [theme.breakpoints.down(1025)]: {
      display:'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
  },
  boardListMenuDiv:{
    color:'#555555', 
    letterSpacing: '-0.8px',
    cursor: 'pointer',   
    "&:hover": {
      color: '#007235',
    },
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },

  
}));



const BoardList = () => {
  const theme = useTheme(); 
  const classes = useStyles(theme);
  let navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [keyword, setKeyword] = useState('')
  const [searchType, setSearchType] = useState(0)

  const [dialog, setDialog] = useState('');

  const [menuVal, setMenuVal] = useState('');

  const login = useSelector(state => state.user.login);

  useEffect(() => {
    if(!login){
      navigate("/Login");
    }

  }, [login])

  const BoardList = [
    {name:'qanda', text:'질문과 답변'},
    {name:'notice', text:'공지사항'},
    {name:'after', text:'사용후기'},
    {name:'fag', text:'자주하는 질문'}
  ]

  const getCartItems = async() => {
    try {
      setLoading(true)
      const res = await axios.get(`/api/board/boardList/${location.state.cateType}`)
      if (res.data.success === false) {
        setDialog('게시판 불러오기 실패')
        setLoading(false)
        return
      }
      setData(res.data.result)
      setLoading(false)
  
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    setMenuVal(BoardList.find(itm => itm.name === location.state.cateType).text)

    if (location.state.cateType) {
      setKeyword('')
      setSearchType(0)
      getCartItems()
    }
  } , [location.state.cateType])

  useEffect(() => {
    

    return () => {
      setData([])
    }
  }, [])


  const getSearchItems = async() => {
    if (keyword === '') return getCartItems()

    try {
      setLoading(true)
      const res = await axios.post('/api/board/searchBoard/', 
        {board_type: location.state.cateType, search_type: searchType, keyword})
      if (res.data.success === false) {
        setDialog('게시판 불러오기 실패')
        setLoading(false)
        return
      }
      setData(res.data.result)
      setLoading(false)
  
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250,
        },
    },
};

  return (
    <div>
      <div className={classes.boardListBlock}>
        <div 
          className={classes.boardListTitleBlock} 
          style={{ backgroundImage:`url(/images/BoardList_banner.png)`}}
        >
          <h1 className={classes.boardListH1}>
            {location.state.cateType && BoardList.find((item) => location.state.cateType === item.name).text}
          </h1>
        </div>
        <div className={classes.row}>
          <div className={classes.boardListDiv}>
            {BoardList.map( (boardmenu, index) => (
              <div 
                key={index} 
                className={classes.boardListMenuDiv}
                onClick={() => { 
                  navigate("/BoardList", {
                    state: { cateType: boardmenu.name }
                  });
                }}
              >
                {boardmenu.text}
              </div>
            ))}
          </div>
          <div className={classes.boardListDivM}>
            <FormControl sx={{ m: 1, width: 300, backgroundColor: '#fff', marginTop: -3, boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', }}>
              <Select
                  value={menuVal}
                  onChange={(e) => setMenuVal(e.target.value)}
                  inputProps={{ 
                      'aria-label': 'Without label' ,
                  }}
                  MenuProps={MenuProps}
                  sx={{
                      backgroundColor: '#fff',
                      height: 50,
                      fontFamily:[
                        'Noto Sans KR'
                      ],
                      textAlign: 'center',
                      '.MuiOutlinedInput-notchedOutline': {
                          border: 'none',
                      },
                  }}
              >      
                {BoardList.map((itm, idx) => (
                  <MenuItem
                    key={idx} 
                    onClick={() => { 
                      navigate("/BoardList", {
                        state: { cateType: itm.name }
                      });
                    }}
                    value={itm.text}
                  >
                      {itm.text}
                  </MenuItem>
                ))}

                  
              </Select>
            </FormControl>
          </div>

        </div>
        
        <div className={classes.dataBox}>
          {loading ?             
            <div className={classes.load}>
              <TbLoader className={classes.loadingIcon}/>
            </div>
            : (
              <BoardType1 
                data={data} 
                cateType={location.state.cateType} 
                getSearchItems={getSearchItems} 
                keyword={keyword}
                setKeyword={setKeyword}
                searchType={searchType}
                setSearchType={setSearchType}
                main
              />
            )         
          }
        </div>
        
      </div>

      <Dialog
          open={dialog === '' ? false : true}
          onClose={() => setDialog('')}
      >
          <DialogTitle id="alert-dialog-title">
              {dialog}
          </DialogTitle>
          <DialogActions>
              <Button onClick={() => setDialog('')} autoFocus>
                  확인
              </Button>
          </DialogActions>
      </Dialog>
    </div>
  )
}

export default BoardList
